<template>
  <div class="page-container">
    <div class="row ml-1">
      <h4 class="mb-4 mr-2">Lista lokalizacji</h4>
      <div v-if="isSuperAdmin">
        <b-button size="sm" @click="add">
          <span data-feather="plus"></span>
          Dodaj
        </b-button>
      </div>
    </div>
    <b-table
      :items="items"
      :fields="fields"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      show-empty
      stacked="md"
      :current-page="currentPage"
      :per-page="perPage"
    >
      <template v-slot:cell(actions)="{ item }">
        <b-button class="btn-primary mr-1" size="sm" @click="edit(item)">Edytuj</b-button>
        <b-button v-if="isSuperAdmin" class="btn-danger mr-1" size="sm" @click="remove(item)"
          >Usuń</b-button
        >
      </template>
    </b-table>

    <b-row>
      <b-col md="12" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  name: 'Localizations',
  mounted() {
    const vm = this
    vm.accountType = localStorage.getItem('account_type')
    vm.listGroups()
  },
  data() {
    return {
      items: [],
      fields: [
        { key: 'name', label: 'Nazwa lokalizacji', sortable: true },
        { key: 'api_key', label: 'Klucz API', sortable: true },
        { key: 'created_at', label: 'Data utworzenia', sortable: true },
        { key: 'updated_at', label: 'Data ostatniej edycji', sortable: true },
        { key: 'actions', label: '' }
      ],
      currentPage: 1,
      totalRows: 0,
      perPage: 6,
      sortBy: '',
      sortDesc: false,
      accountType: ''
    }
  },
  watch: {
    items() {
      this.updateUI()
    }
  },
  methods: {
    add() {
      this.$router.push({ name: 'e-zacma-localization-create' })
    },
    listGroups() {
      const vm = this
      vm.$store.commit('addPageLoaderEvent', 'list-localizations')
      vm.$http
        .post('e-zacma/get-allowed-api-keys')
        .then(response => {
          vm.items = response.data
        })
        .catch(e => vm.$handleLaravelFormErrorResponse(e))
        .finally(() => {
          vm.$store.commit('removePageLoaderEvent', 'list-localizations')
        })
    },
    edit(item) {
      this.$router.push({ name: 'e-zacma-localization-modify', params: { id: item.id } })
    },
    updateUI() {
      this.totalRows = this.items.length
    },
    remove(item) {
      const vm = this
      vm.$bvModal
        .msgBoxConfirm(
          `Czy na pewno chcesz usunąć lokalizację "${item.name}"? Wynik tej operacji jest nieodwracalny.`,
          {
            title: 'Usuwanie lokalizacji',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'danger',
            okTitle: 'Tak',
            cancelTitle: 'Nie',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true
          }
        )
        .then(value => {
          if (value) {
            vm.$store.commit('addPageLoaderEvent', 'remove-localization')
            vm.$http
              .post('e-zacma/localization/remove', { id: item.id })
              .then(response => {
                vm.listGroups()
                vm.$toast.success({
                  message: `Lokalizacja "${item.name}" została skasowana.`
                })
              })
              .catch(e => vm.$error())
              .finally(() => {
                vm.$store.commit('removePageLoaderEvent', 'remove-localization')
              })
          }
        })
    }
  },
  computed: {
    isSuperAdmin() {
      return this.accountType === 'super_admin'
    }
  }
}
</script>

<style scoped></style>
